import * as React from "react";
import { useFormContext } from "@grandvisionhq/forms";
import { useSelector, useDispatch } from "@grandvisionhq/state";
import { ShippingObjectTypes } from "../../../../../../state.js";
import { saveAddressLookup } from "../../../../../../StepShipping/StepShipping/actions.js";
import { getDeliveryAddress, getBillingAddress } from "../../../../../../StepShipping/StepShipping/selectors.js";
import { AddressLookup } from "../../../../components/modules/AddressLookup/components/AddressLookup.js";
import { validateInputField } from "../../../../utils/modules/AddressLookup/utils/validate-input-field.js";
import { mapDataToFormValues } from "../../../../utils/modules/AddressLookup/utils/map-data-to-form-values.js";
import { useCheckoutSettings } from "../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const AddressLookupContainer = ({
  errorMessage: initialErrorMessage,
  inputFieldName = "streetName",
  label,
  maxLength,
  validations,
  validationsWithErrorMessages
}) => {
  const [isTouched, setIsTouched] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(initialErrorMessage);
  const deliveryAddress = useSelector(getDeliveryAddress);
  const billingAddress = useSelector(getBillingAddress);
  const { addressLookup } = useCheckoutSettings();
  const { name, onChange, getInitialState } = useFormContext();
  const currentForm = name === ShippingObjectTypes.BillingAddress ? billingAddress : deliveryAddress;
  const initialState = getInitialState && getInitialState(inputFieldName);
  const dispatch = useDispatch();
  const updateStore = React.useCallback(
    (prefillData) => {
      const dynamicForm = name === ShippingObjectTypes.BillingAddress ? { billingAddress: ShippingObjectTypes.BillingAddress } : { deliveryAddress: ShippingObjectTypes.DeliveryAddress };
      Object.entries(dynamicForm).forEach(([_, checkoutFormName]) => {
        dispatch(
          saveAddressLookup({
            formName: checkoutFormName,
            formData: {
              streetName: prefillData?.streetName || "",
              streetNumber: prefillData?.streetNumber,
              city: prefillData?.city,
              postalCode: prefillData?.postalCode,
              region: prefillData?.region
            }
          })
        );
      });
    },
    [dispatch, name]
  );
  const validateInput = React.useCallback(
    (value, initialErrorMessage2 = "") => {
      const { isValid, errorMessage: errorMessage2 } = validateInputField(
        true,
        value,
        initialErrorMessage2,
        validations,
        validationsWithErrorMessages,
        maxLength
      );
      setErrorMessage(errorMessage2);
      return isValid;
    },
    [maxLength, validations, validationsWithErrorMessages]
  );
  const updateForm = React.useCallback(
    (value, initialRender) => {
      onChange && onChange({
        name: inputFieldName,
        value,
        isTouched: initialRender ? !!initialState?.isTouched : true,
        isValid: validateInput(value)
      });
    },
    [onChange, inputFieldName, initialState?.isTouched, validateInput]
  );
  const handleOnResult = React.useCallback(
    (data) => {
      const formattedData = mapDataToFormValues(data, addressLookup);
      const prefillData = {
        ...currentForm,
        ...formattedData
      };
      updateForm(prefillData.streetName);
      updateStore(prefillData);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentForm?.firstName, currentForm?.lastName]
  );
  const handleIsTouched = React.useCallback(() => {
    setIsTouched(true);
  }, []);
  const handleOnChange = React.useCallback(
    (initialState2) => {
      if (onChange) {
        onChange({
          name: inputFieldName,
          value: initialState2.value,
          isTouched: initialState2.isTouched || isTouched || Boolean(initialState2.value),
          isValid: validateInput(initialState2.value, initialErrorMessage)
        });
      }
    },
    [initialErrorMessage, inputFieldName, isTouched, onChange, validateInput]
  );
  React.useEffect(() => {
    if (!initialState) {
      return;
    }
    handleOnChange(initialState);
  }, [initialState?.isTouched, initialState?.value, initialState?.isValid]);
  React.useEffect(() => {
    !currentForm?.streetName && updateForm("", true);
  }, []);
  return /* @__PURE__ */ React.createElement(
    AddressLookup,
    {
      hasDisplayError: !Boolean(initialState?.isValid) && (Boolean(initialState?.isTouched) || isTouched),
      isDisplayIsValid: Boolean(initialState?.isValid) && (Boolean(initialState?.isTouched) || isTouched),
      errorMessage,
      inputFieldName,
      label,
      setIsTouched: handleIsTouched,
      onResult: handleOnResult,
      streetName: initialState?.value || "",
      updateForm
    }
  );
};
export {
  AddressLookupContainer
};
//# sourceMappingURL=AddressLookupContainer.js.map
